import { render } from "./HeaderMobile.vue?vue&type=template&id=188b4ba4"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__